// admin-ui/src/lib/supabaseClient.ts
import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!url || !anon) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY')
}

export const supabase = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // storage ist optional – default ist localStorage im Browser
    // storage: window.localStorage,
  },
})

// Debug (optional)
if (typeof window !== 'undefined') {
  // @ts-ignore
  window.supabase = supabase
}
